import { createContext, type ReactNode, useContext, useState } from 'react';
import type { ExcMarketdataV1ChartPoint } from '@interxfi/types';
import { noop } from '@interxfi/utilities/fn/no-op';
import type { MarketDataPriceBaseline } from './market-data-quote-price-display';

export interface MarketDataInspection {
  point: ExcMarketdataV1ChartPoint;
  baseline: MarketDataPriceBaseline;
}

const MarketDataInspectionContext = createContext<MarketDataInspection | null>(null);
const MarketDataInspectionSetterContext = createContext<(inspection: MarketDataInspection | null) => void>(noop);

export function MarketDataInspectionProvider({ children }: { children: ReactNode }) {
  const [inspection, setInspection] = useState<MarketDataInspection | null>(null);

  return (
    <MarketDataInspectionSetterContext.Provider value={setInspection}>
      <MarketDataInspectionContext.Provider value={inspection}>{children}</MarketDataInspectionContext.Provider>
    </MarketDataInspectionSetterContext.Provider>
  );
}

export function useMarketDataInspection() {
  return useContext(MarketDataInspectionContext);
}

export function useSetMarketDataInspection() {
  return useContext(MarketDataInspectionSetterContext);
}
